import styled from 'styled-components'
import { ButtonBase } from 'src/comps/Atom/Buttons/Button/styles'

import { updatedMedia } from 'client/styles'

export const OmniSearchContent = styled.div`
  display: flex;
  align-items: center;
`

export const OmniSearchBase = styled.div<{ isEbooking?: boolean; disabled?: boolean }>`
  position: relative;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  --search-items-height: 56px;
  --inputs-border-radius: 100px;

  width: 100%;
  max-width: 1000px;

  &.readonly,
  &.borderless {
    ${props => (props.isEbooking ? `background-color: ${props.theme.colors.grey8};` : '')}
    display: flex;
    align-items: center;
    border: 2px solid ${({ theme }) => theme.colors.grey5};
    border-radius: 50px;
  }

  &.readonly {
    flex-wrap: wrap;
    padding-block: 5px 6px;
    padding-inline: 36px 10px;
    margin-inline: 12px;
    margin-block: 0;
    max-width: calc(100% - 24px);
    overflow: hidden;
    svg {
      position: absolute;
      fill: ${({ theme }) => theme.colors.grey3};
      inset-inline-start: 10px;
      inset-block-start: calc(50% - 10px);
    }
  }

  &.borderless {
    padding-block: 3px;
    padding-inline: 3px;
    border: 2px solid var(--color--neutral--400);
    border-radius: var(--inputs-border-radius);
    height: var(--search-items-height);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--color-neutral-100);

    ${ButtonBase} {
      line-height: 16px;
      padding-block: 10px;
      padding-inline: 12px;
      border-radius: 50px;

      ${updatedMedia.onlyTablet} {
        margin-inline: 8px 0;
        margin-block: 8px;
        width: 48px;
        height: 48px;
      }

      ${updatedMedia.desktop} {
        width: max-content;
      }

      & .buttonText {
        ${updatedMedia.onlyTablet} {
          display: none;
        }

        ${updatedMedia.desktop} {
          display: inline;
        }
      }
    }
  }

  &.full {
    flex-direction: column;
    z-index: 11;
    border: 2px solid var(--color--neutral--400);
    border-radius: 35px;

    > ${ButtonBase} {
      padding-block: 10px;
      padding-inline: 12px;
      width: calc(100% - 24px);
      border-radius: 50px;
      margin-inline: auto;
      margin-block: 8px;
    }
  }
`
